import React, { createContext } from 'react'
export const MWContext = createContext()

const MWContextProvider = (props) => {

    const IMAGE_ROOT = "https://www.malwaregame.com/game_assets"

    return (
         <MWContext.Provider 
            value={{
                IMAGE_ROOT
             }}>
               {props.children}
         </MWContext.Provider>
    )
}
export default MWContextProvider
